import { Injectable } from '@angular/core';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IValueTemplate } from 'src/app/xena-api/dtos';
import { IValueTemplateFilter } from 'src/app/xena-api/filters';

@Injectable({
  providedIn: 'root'
})
export class ValueTemplateService extends BaseService<IValueTemplate, IValueTemplateFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'ValueTemplate')
  }
}
